import React, { FC } from 'react';

import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { IKImage } from '../../../../components/IKImage';
import { CustomButton } from '../../../../components/UI/CustomButton';
import useStyles from '../AccountDetailsView/styles';
import useOrganizationStyles from '../OrganizationForm/styles';

interface OrganizationViewProps {
  setFormEnabled: Function;
  companyShortName?: string | null;
  companyLogo?: string | null;
}

const OrganizationView: FC<OrganizationViewProps> = ({
  companyLogo,
  companyShortName,
  setFormEnabled,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const organizationClasses = useOrganizationStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.info}>
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>{t('page.account.displayName')}</Typography>
          <span>{companyShortName ? companyShortName : '-'}</span>
        </Box>
        <Box className={classes.infoCellPlaceholder} />
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>
            {t('page.account.organizationLogo')}
          </Typography>
          {companyLogo ? (
            <IKImage
              className={organizationClasses.logo}
              path={companyLogo}
              srcset={[{ width: 140 }]}
              sizes="100vw"
            />
          ) : (
            '-'
          )}
        </Box>
      </Box>
      <CustomButton id="edit-btn" btnClass={classes.btn} onClick={() => setFormEnabled(true)}>
        {t('button.edit')}
      </CustomButton>
    </Box>
  );
};

export default OrganizationView;
